// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__supplyChainsSanctionsCompliance--_tBUT{overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/pages/SupplyChainsSanctionsCompliance/styles.module.scss"],"names":[],"mappings":"AAAA,uDACE,iBAAA","sourcesContent":[".supplyChainsSanctionsCompliance {\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"supplyChainsSanctionsCompliance": `styles-module__supplyChainsSanctionsCompliance--_tBUT`
};
export default ___CSS_LOADER_EXPORT___;
